<template>
    <svg class="group fill-purple dark:fill-white text-purple dark:text-white transition-colors" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="14.2857" stroke="currentColor" stroke-width="1.42857" fill="none"/>

        <path class="absolute visible group-hover:invisible transition-all" d="M15.0003 24.2857C12.5198 24.2857 10.1876 23.3203 8.4336 21.5667C6.67962 19.8131 5.71387 17.4805 5.71387 14.9993C5.71387 12.5188 6.67962 10.1869 8.4336 8.43331C10.1876 6.67899 12.5198 5.71289 15.0003 5.71289C15.1994 5.71289 15.4059 5.71987 15.6145 5.73312C12.638 7.2726 10.7146 10.9089 10.7146 14.9993C10.7146 19.0869 12.6363 22.7246 15.6106 24.2662C15.3993 24.2794 15.1942 24.2857 15.0003 24.2857V24.2857Z"/>

        <ellipse class="absolute invisible group-hover:visible transition-all" cx="14.9957" cy="14.9966" rx="9.28572" ry="9.28565"/>
    </svg>
</template>

<script>
export default {
    name: 'ThemeIcon',
}
</script>
